import React from 'react';
import {Modal} from 'react-bootstrap';

const DeleteMailerTagForm = (props)=>{
    const {mailerTag, onHide, onConfirm} = props;
    return (
        <Modal
            show={true}
            onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar tag</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p>¿Estás seguro que deseas eliminar el tag&nbsp;<strong>{mailerTag.name}</strong>?</p>
                <p>Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( mailerTag ) }>Eliminar</button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteMailerTagForm;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/DeleteMailerTagModal/index.jsx